<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wQLoU2/tc-custom/9781446357347.jpg?1705766123450" alt="This image is the cover for the book Make Me I'm Yours ... Sewing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Make Me I'm Yours ... Sewing
      </h1>
      <p class="bookDescription body article font2">
        <b>Learn how to sew with this stylish collection of twenty irresistible hand and sewing machine projects, including bags, gifts, and pillows.</b><br/><br/>Discover the pleasure of making your own chic and unique designs with these simple-to-make patterns. Transform yourself from a needlecraft novice to an embellishment expert with this sewing savvy guide. Choose from pretty and stylish gift ideas for you and your friends and go fabric shopping today.<br/><br/>This book is packed with ideas, needlecraft techniques, step-by-step instructions, and handy tips to make it fun and easy. It has ideas for you and your home, from beautiful bags to vibrant cushions. Everyone will find a project they adore.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Various
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47c4e0be